import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Washington State Portal": {
    parameters: {
      linkUrls: ["https://secureaccess.wa.gov/myAccess/saw/select.do"],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "WA",
  },
  "Washington 312 Exemption Form": {
    parameters: {
      linkUrls: ["https://apps.ecology.wa.gov/publications/documents/ecy070645.pdf"],
      staffInputs: {
        documentTypes: {
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "WA",
  },
};
